import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { IConfirmDialog } from "../interfaces/modal";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-confirm-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, CommonModule],
  templateUrl: "./confirm-dialog.component.html",
  styleUrl: "./confirm-dialog.component.css",
})
export class ConfirmDialogComponent {
  @Input() title!: string;
  @Input() message!: any;
  @Output() confirmAction: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelAction: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data = IConfirmDialog
  ) {}

  confirm(): void {
    this.confirmAction.emit();
  }

  cancel(): void {
    this.cancelAction.emit();
  }
}
